import { render, staticRenderFns } from "./_base-loading-skeleton.vue?vue&type=template&id=50d5c26a&scoped=true&"
import script from "./_base-loading-skeleton.vue?vue&type=script&lang=js&"
export * from "./_base-loading-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./_base-loading-skeleton.vue?vue&type=style&index=0&id=50d5c26a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d5c26a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50d5c26a')) {
      api.createRecord('50d5c26a', component.options)
    } else {
      api.reload('50d5c26a', component.options)
    }
    module.hot.accept("./_base-loading-skeleton.vue?vue&type=template&id=50d5c26a&scoped=true&", function () {
      api.rerender('50d5c26a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base-loading-skeleton.vue"
export default component.exports